export default __webpack_public_path__ + "421dd607913f5d7089b4af1ead6bc976.png";